import React from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white text-slate-600 pt-12 lg:pt-20 pb-12 border-t border-gray-200" role="contentinfo" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-48">
          {/* Col 1: Brand */}
          <div className="col-span-2 lg:col-span-1" data-id="element-49">
            <Link to="/" className="inline-block mb-6" aria-label="Ambient Fingerprinting - Home" data-id="element-50">
              <img src="https://cdn.magicpatterns.com/uploads/45tD6GiCQLAvjHvfZnL4vs/cropped-Media__1_-removebg-preview.png" alt="Ambient Fingerprinting" className="h-10 md:h-12 w-auto object-contain" style={{
              filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.05)) brightness(0.95)'
            }} data-id="element-51" />
            </Link>
            <p className="text-gray-600 leading-relaxed text-sm" data-id="element-52">
              With over a decade of experience, our team ensures exceptional
              quality and attention to detail, consistently exceeding
              expectations and setting new standards of service excellence.
            </p>
          </div>

          {/* Col 2: Company */}
          <div data-id="element-53">
            <h3 className="text-slate-900 font-bold text-lg mb-8" data-id="element-54">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-55">
              <li data-id="element-56">
                <Link to="/about" className="text-slate-600 hover:text-[#4AA6CF] transition-colors font-semibold" data-id="element-57">
                  About Us
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/pricing" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-59">
                  Booking/Pricing
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/resources" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-61">
                  Resources & Forms
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/contact" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-63">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div data-id="element-64">
            <h3 className="text-slate-900 font-bold text-lg mb-8" data-id="element-65">Services</h3>
            <ul className="space-y-4" data-id="element-66">
              <li data-id="element-67">
                <Link to="/services" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-68">
                  Live Scan Fingerprinting
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/services" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-70">
                  Mobile / Group Service
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/services" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-72">
                  Background Checks
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/booking" className="text-gray-600 hover:text-[#4AA6CF] transition-colors font-medium" data-id="element-74">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div data-id="element-75">
            <h4 className="text-slate-900 font-bold text-lg mb-8" data-id="element-76">
              Contact Us
            </h4>
            <ul className="space-y-4" role="list" data-id="element-77">
              <li className="flex items-start gap-3 text-sm text-gray-600" data-id="element-78">
                <MapPinIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-79" />
                <span data-id="element-80">
                  10632 Little Patuxent Pkwy, Suite 302, Columbia, MD 21044
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-slate-600" data-id="element-81">
                <PhoneIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0" aria-hidden="true" data-id="element-82" />
                <a href="tel:4105255285" className="hover:text-[#4AA6CF] transition-colors font-bold" data-id="element-83">
                  410-525-5285
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-gray-600" data-id="element-84">
                <ClockIcon className="h-5 w-5 text-[#4AA6CF] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-85" />
                <span data-id="element-86">
                  Mon-Fri 7am-7pm
                  <br data-id="element-87" />
                  Sat 9am-5pm (by appointment)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-10 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-88">
          <p className="text-slate-400 text-sm font-medium text-center md:text-left" data-id="element-89">
            &copy; 2026 Ambient Solutions, LLC. DBA Ambient Fingerprinting
            Solution.
          </p>
          <p className="text-slate-400 text-sm font-medium" data-id="element-90">
            Designed with care
          </p>
        </div>
      </div>
    </footer>;
}